import { ReactComponent as Calendar } from './assets/calendar.svg';
import { ReactComponent as Check } from './assets/check.svg';
import { ReactComponent as ChevronDown } from './assets/chevronDown.svg';
import { ReactComponent as ChevronLeft } from './assets/chevronLeft.svg';
import { ReactComponent as ChevronRight } from './assets/chevronRight.svg';
import { ReactComponent as CircleCheck } from './assets/circleCheck.svg';
import { ReactComponent as CircleGreyX } from './assets/circleGreyX.svg';
import { ReactComponent as CircleX } from './assets/circleX.svg';
import { ReactComponent as Clock } from './assets/clock.svg';
import { ReactComponent as DollarCircle } from './assets/dollarCircle.svg';
import { ReactComponent as Download } from './assets/download.svg';
import { ReactComponent as Dropdown } from './assets/dropdown.svg';
import { ReactComponent as ExclamationCircleRed } from './assets/exclamationCircleRed.svg';
import { ReactComponent as Exit } from './assets/exit.svg';
import { ReactComponent as Info } from './assets/info.svg';
import { ReactComponent as MaLogo } from './assets/maLogo.svg';
import { ReactComponent as MaLogoFull } from './assets/maLogoFull.svg';
import { ReactComponent as Search } from './assets/search.svg';
import { ReactComponent as WhyInfoDog } from './assets/whyInfoDog.svg';
import { ReactComponent as X } from './assets/x.svg';

type SVGType = React.FC<React.SVGProps<SVGSVGElement>>;

const Icons: Record<string, SVGType> = {
    Calendar,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    Check,
    CircleCheck,
    CircleGreyX,
    CircleX,
    Clock,
    DollarCircle,
    Download,
    Dropdown,
    ExclamationCircleRed,
    Exit,
    Info,
    MaLogo,
    MaLogoFull,
    Search,
    WhyInfoDog,
    X,
};

export default Icons;
